import React, { useContext } from "react";
import { AppContext } from "../context/AppContext";
import { RouterParams } from "../router/RouterParams";

import {
    prepareAndSendAccountsPayable
} from "../api/ProviderSECfdiApi";
import { PrepareAndSendAccountsPayableRequest, PrepareCfdiRequest } from "../model/CfdiSe";
import { SendCfdisResponse } from "../model/ProviderCfdi";
import CfdiIssuedPrepareAnyForm, { PrepareResponses } from "./CfdiIssuedPrepareAnyForm";

export interface CfdiIssuedPrepareAndSendAccountsPayableFormProps extends RouterParams {
    onCancel: () => void;
    sendCfdiRequest: PrepareAndSendAccountsPayableRequest;
    onSubmitSuccess: (response: SendCfdisResponse) => void;
    onSubmitError: (error: Error) => void;
}

export default function CfdiIssuedPrepareAndSendAccountsPayableForm({
    match,
    sendCfdiRequest,
    onCancel,
    onSubmitSuccess,
    onSubmitError,
}: CfdiIssuedPrepareAndSendAccountsPayableFormProps) {
    const context = useContext(AppContext);
    const tenantId = context.session?.tenant?.id ?? "-";
    const providerId = context.session?.provider?.id;

    const promisePrepare = (prepareRequest: PrepareCfdiRequest) => {
        const request = {
            ...prepareRequest,
            ...sendCfdiRequest,
        }
        return prepareAndSendAccountsPayable(tenantId, providerId!, request);
    };

    return (
        <CfdiIssuedPrepareAnyForm
            match={match}
            promiseCfdi={() => Promise.resolve(undefined)}
            promisePrepare={promisePrepare}
            onSubmitSuccess={(response: PrepareResponses) => {
                return onSubmitSuccess(response as SendCfdisResponse);
            }}
            onSubmitError={onSubmitError}
            onCancel={onCancel}
            displayTitleActions={false}
            variant="embedded"
        />
    );
}
